module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_3.d24a6185.png";